import { GridApi, IRowNode } from 'ag-grid-community';

import { SetupFrameInformation } from '../Setup.types';
import { isPollingState } from '../utils';

export const SETUP_POLL_INTERVAL_MS = 4000;

export const applySetupDeltas = (gridApi: GridApi, deltas: SetupFrameInformation[]): void => {
  const deltaByFileId = new Map(deltas.map((row) => [row.fileId, row]));

  gridApi.forEachNode((node: IRowNode) => {
    if (!node.data?.fileId) {
      return;
    }

    const delta = deltaByFileId.get(node.data.fileId);

    if (delta) {
      node.setData({ ...node.data, ...delta });
    }
  });

  gridApi.refreshCells({ force: true });
};

export const getSetupRows = (gridApi?: GridApi): SetupFrameInformation[] => {
  const rows: SetupFrameInformation[] = [];

  gridApi?.forEachNode((node: IRowNode) => {
    if (node.data) {
      rows.push(node.data as SetupFrameInformation);
    }
  });

  return rows;
};

export const hasPollingStateRows = (rows: SetupFrameInformation[]): boolean =>
  rows.some((row) => isPollingState(row.processingState));

export const getSetupErrorReportFilename = (contentDisposition?: string): string | undefined => {
  const match = contentDisposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);

  return match?.[1]?.replace(/['"]/g, '');
};
